import client from "../Client/HttpClient";
import {IDutiesModel} from "@/interfaces/modules";
const ApiPath = "SystemDuties";

export default {
    GetSystemDuties:() : Promise <IDutiesModel[]> => client.get(`${ApiPath}`),
    GetSystemDutiesbyId: (data: IDutiesModel): Promise <IDutiesModel> => client.get(`${ApiPath}/${data.Id}`), 
    PostSystemDuties: (data: IDutiesModel): Promise<IDutiesModel> => client.post(`${ApiPath}`, data)
  };